import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {CoreModule} from '../../core/core.module';
import {SharedModule} from '../../shared/shared.module';
import {PresetRoutingModule} from './preset-routing.module';
import { BattleListComponent } from "./components/battle/battle-list/battle-list-component";
import { BattleDetailsComponent } from "./components/battle/battle-details/battle-details-component";
import { NgxMasonryModule } from "ngx-masonry";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        CoreModule,
        SharedModule,
        PresetRoutingModule,
        NgxMasonryModule,
    ],
    declarations: [
        BattleListComponent, BattleDetailsComponent
    ],
    entryComponents: [
        BattleListComponent, BattleDetailsComponent
    ]
})
export class PresetModule {
}
